import StaticLanguagePage from '../StaticLanguagePage';
import italianPageData from './italianPageData';

export default function ItalianStaticPage() {
  return <StaticLanguagePage language={italianPageData} />;
}
